import { useCart, useUpsertCartItem } from '@/api/carts/carts.hooks';
import { DeleteForever } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ClearCartButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

export function ClearCartButton({
  variant = 'text',
  size = 'small',
  fullWidth = false,
}: ClearCartButtonProps) {
  const { t } = useTranslation(['customer', 'common']);
  const { data } = useCart();
  const { mutateAsync: upsertCartItem } = useUpsertCartItem();
  const [openDialog, setOpenDialog] = useState(false);
  const cartItems = data?.cartItems || [];
  const cartCount = cartItems.length;

  const handleClearCart = async () => {
    await upsertCartItem({
      cartItems: cartItems.map((item) => ({
        itemId: item.itemId,
        quantity: 0,
      })),
    });
    setOpenDialog(false);
  };

  return (
    <>
      <Button
        startIcon={<DeleteForever />}
        size={size}
        variant={variant}
        onClick={() => setOpenDialog(true)}
        disabled={cartCount === 0}
        fullWidth={fullWidth}
      >
        {t('customer:items.cart.clearCart')}
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('customer:items.cart.clearCart')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('customer:items.cart.clearCartConfirm')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>
            {t('common:actions.cancel')}
          </Button>
          <Button onClick={handleClearCart} variant="contained" color="error">
            {t('customer:items.cart.clearCart')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
